import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as actions from '@appStore/selfservice/actions';
import { BookingActionTypes } from '@appStore/selfservice/actions';
import { BookingsService } from '@appStore/selfservice/services';

@Injectable()   
export class BookingEffects {
    constructor(private bookingsService: BookingsService, private actions$: Actions) {}
  
    loadBookingServices$ = createEffect(() => {
      return this.actions$.pipe(
        ofType(BookingActionTypes.BookingServicesLoad),
        exhaustMap(action => {
          return this.bookingsService.getBookingServices().pipe(
            map(bookingServices => new actions.BookingServicesLoadSuccess(bookingServices)),
            catchError(error => of(new actions.BookingServicesLoadFail(error)))
          );
        })
      );
    });

    loadSchedulingPolicy$ = createEffect(() => {
      return this.actions$.pipe(
        ofType(BookingActionTypes.SchedulingPolicyLoad),
        exhaustMap((action: actions.SchedulingPolicyLoad) => {
          return this.bookingsService.getSchedulingPolicy(action.payload.bookingBusinessId, action.payload.serviceId).pipe(
            map(schedulingPolicy => new actions.SchedulingPolicyLoadSuccess(schedulingPolicy)),
            catchError(error => of(new actions.SchedulingPolicyLoadFail(error)))
          );
        })
      );
    });

    loadStaff$ = createEffect(() => {
      return this.actions$.pipe(
        ofType(BookingActionTypes.StaffsLoad),
        exhaustMap((action: actions.StaffsLoad) => {
          return this.bookingsService.getStaffs(action.payload.bookingBusinessId, action.payload.serviceId, action.payload.customerId).pipe(
            map(staffs => new actions.StaffsLoadSuccess(staffs)),
            catchError(error => of(new actions.StaffsLoadFail(error)))
          );
        })
      );
    });

    loadStaffAvailability$ = createEffect(() => {
      return this.actions$.pipe(
        ofType(BookingActionTypes.StaffAvailabilityLoad),
        exhaustMap((action: actions.StaffAvailabilityLoad) => {
          return this.bookingsService.getAvailabilitySlots(action.payload.bookingBusinessId, action.payload.staffIds, action.payload.startDate, action.payload.endDate).pipe(
            map(availability => new actions.StaffAvailabilityLoadSuccess(availability)),
            catchError(error => of(new actions.StaffAvailabilityLoadFail(error)))
          );
        })
      );
    });

    createAppointment$ = createEffect(() => {
      return this.actions$.pipe(
        ofType(BookingActionTypes.CreateAppointment),
        exhaustMap((action: actions.CreateAppointment) => {
          return this.bookingsService.createAppointment(action.payload).pipe(
            map(() => new actions.CreateAppointmentSuccess(true)),
            catchError(error => of(new actions.CreateAppointmentFail(error)))
          );
        })
      );
    });

    loadServiceCustomQuestions$ = createEffect(() => {
      return this.actions$.pipe(
        ofType(BookingActionTypes.ServiceCustomQuestionsLoad),
        exhaustMap((action: actions.ServiceCustomQuestionsLoad) => {
          return this.bookingsService.getServiceCustomQuestions(action.payload.bookingBusinessId, action.payload.serviceId).pipe(
            map(questions => new actions.ServiceCustomQuestionsLoadSuccess(questions)),
            catchError(error => of(new actions.ServiceCustomQuestionsLoadFail(error)))
          );
        })
      );
    });
}